<template>
  <div class="site" :class="{ 'has-flight-warning': showBanner }">
    <!-- Flight Search Down Warning Banner -->
    <div v-if="showBanner" class="flight-search-warning">
      <div
        class="notification has-text-centered is-size-6 is-warning"
        :style="{
          margin: 0,
          position: 'fixed',
          top: '0px',
          width: '100%',
          'z-index': 40,
          padding: '12px 1rem',
          borderBottom: '2px solid #d4a200',
          opacity: '0.9'
        }"
      >
        <div class="columns is-mobile is-vcentered">
          <div class="column">
            <b-icon icon="alert-circle" size="is-small" class="mr-2"></b-icon>
            <strong>May 18, 2026 - We're experiencing intermittent booking issues</strong> - Please check back again later or call our agents at <strong><a href="tel:877-924-0303">877-924-0303</a></strong> to book.
          </div>
        </div>
      </div>
    </div>

    <MainNavBar v-if="!isMeeting" @logout="$app.logout" />

    <main
      class="my-6 site__content"
      :class="{
        site__padding: !isMeeting,
        'gant-together-body': pathMixin_isMeetingLandingPage,
      }"
    >
      <router-view />
    </main>
    <AutoLogoutTimer
      v-if="$globals.profile.firstName !== ''"
      class="pulled-right"
      @logout="$app.logout"
    />
    <MainFooter v-if="!isMeeting" />
  </div>
</template>

<script>
import MainFooter from "@/components/Layout/Footer.vue";
import MainNavBar from "@/components/Layout/MainNavBar.vue";
import AutoLogoutTimer from "@/components/Layout/AutoLogoutTimer.vue";

export default {
  components: {
    MainFooter,
    MainNavBar,
    AutoLogoutTimer,
  },
  computed: {
    isMeeting() {
      return this.pathMixin_isMeeting || this.pathMixin_isMeetingLandingPage;
    },
    isLoggedIn() {
      return Object.keys(this.$globals.profile).length > 0;
    },
    showBanner() {
      return false;
      // return !this.isMeeting && this.isLoggedIn;
    },
  },
};
</script>

<style scoped>
/* Push navbar and content down when flight warning banner is visible */
.site.has-flight-warning >>> .navbar.is-fixed-top {
  top: 48px !important;
}

.site.has-flight-warning .site__content {
  padding-top: 48px;
}

/* Tablets */
@media (max-width: 1024px) {
  .site.has-flight-warning >>> .navbar.is-fixed-top {
    top: 70px !important;
}

.site.has-flight-warning .site__content {
  padding-top: 70px;
}
}

/* Mobiler */
@media (max-width: 480px) {
  .site.has-flight-warning >>> .navbar.is-fixed-top {
    top: 100px !important;
}

.site.has-flight-warning .site__content {
  padding-top: 100px;
}
}
</style>

